import { option_question, option_level } from "../../../service/option";

import { classNames } from "primereact/utils";
import { Button } from "primereact/button";
import { Checkbox } from "primereact/checkbox";

export default function ModuleQuestionType3({ closePrePop, popPreOption }) {
  const renderItem = ({ text }) => (
    <>
      <div className="flex align-items-start">
        <i
          className="pi pi-send text-sm rotate-45 mr-2"
          style={{ marginTop: "0.6rem" }}
        ></i>
        <span>{text}</span>
      </div>
    </>
  );

  return (
    <>
      <div className="px-3">
        <div className="line-height-4 mt-3">
          {renderItem({
            text: "採五分李克式計分，1分至5分為「極度沒自信」至「極度有自信」，總分越高，代表個人對於其生涯發展能力越有自信",
          })}
          {renderItem({
            text: "分為四大構面生涯活動參與(Engagement)、自我了解(Self-understanding)、生涯軌跡探索(Career and pathway exploration)、生涯規劃管理(Planning and career management)",
          })}
          {renderItem({ text: "構面定義" })}
          <div style={{ marginLeft: "1.3rem" }}>
            <div className="flex align-items-start">
              <div className="mr-1">(1)</div>
              <div>
                活動參與(Engagement)：參與新經歷、擴展與他人及社區的聯繫，以及保持參與職業和生涯規劃活動的興趣與能力。
              </div>
            </div>
            <div className="flex align-items-start mt-1">
              <div className="mr-1">(2)</div>
              <div>
                自我了解(Self-understanding)：理解自己對工作和生活的期望和夢想，參與自我省思和自我提升的相關活動，並能將自我認識與不同生涯途徑連結。
              </div>
            </div>
            <div className="flex align-items-start mt-1">
              <div className="mr-1">(3)</div>
              <div>
                生涯軌跡探索(Career and pathway
                exploration)：能夠探索多樣的生涯途徑和多種工作形式，並可加以優先排序比較不同途徑的選擇，同時設定職業和生活的目標。
              </div>
            </div>
            <div className="flex align-items-start mt-1">
              <div className="mr-1">(4)</div>
              <div>
                生涯規劃管理(Planning and career
                management)：尋求支持和機會、克服障礙並能有效管理職業過渡和發展的能力。
              </div>
            </div>
          </div>
        </div>

        <table className="w-full mt-2">
          <thead>
            <tr>
              <th className="border-bottom-1 border-500"></th>
              {option_level.type3.map((lvItem) => (
                <th
                  key={lvItem.value}
                  className="border-bottom-1 border-500 py-2"
                >
                  {lvItem.label}
                </th>
              ))}
            </tr>
          </thead>
          <tbody>
            {option_question.type3.map((qItem, qIdx) => (
              <tr key={qItem.key}>
                <td
                  className={classNames({
                    "border-bottom-1 border-500": [3, 7, 12, 16].includes(qIdx),
                  })}
                >
                  {qItem.title}
                </td>
                {option_level.type3.map((lvItem) => (
                  <td
                    key={`${qItem.key}_${lvItem.value}`}
                    className={classNames("text-center py-2", {
                      "border-bottom-1 border-500": [3, 7, 12, 16].includes(
                        qIdx
                      ),
                    })}
                  >
                    <Checkbox
                      name={qItem.key}
                      value={lvItem.value}
                      checked={popPreOption.data?.[qItem.key] === lvItem.value}
                      disabled={true}
                    />
                  </td>
                ))}
              </tr>
            ))}
          </tbody>
        </table>

        <div className="text-right mt-3">
          <Button
            className="p-button-secondary w-auto px-3"
            type="button"
            label="關閉"
            onClick={() =>
              closePrePop({
                type: "question",
              })
            }
          />
        </div>
      </div>
    </>
  );
}
